<template>
  <DocumentTextIcon class="w-4 h-4 text-gray-500" />
</template>

<script>
import { DocumentTextIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'FileIcon',
  components: { DocumentTextIcon },
};
</script>
